module.exports = __webpack_public_path__ + "img/mao01.7e91b3d2.svg";